import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '@/app/baseQuery';
import type { Notification } from '@/api/types/notification-types';

const PAGE_SIZE = 100;

export interface GetNotificationsParams {
  profileId: string;
  page?: number;
  pageSize?: number;
}

interface MarkNotificationReadParams {
  profileId: string;
  notificationId: string;
}

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Notifications'],
  endpoints: builder => ({
    getNotifications: builder.query<Notification[], GetNotificationsParams>({
      query: ({ profileId, page = 1, pageSize = PAGE_SIZE }) => ({
        url: `profiles/${profileId}/notifications`,
        params: {
          'page[number]': page,
          'page[size]': pageSize,
          sort: '-created-at',
          include: 'comments,profiles,messages,entries'
        }
      }),
      providesTags: ['Notifications']
    }),
    markNotificationRead: builder.mutation<void, MarkNotificationReadParams>({
      query: ({ profileId, notificationId }) => ({
        url: `profiles/${profileId}/notifications/${notificationId}`,
        method: 'PATCH',
        body: {
          data: {
            id: notificationId,
            type: 'notifications',
            attributes: { state: 'read' }
          }
        }
      }),
      invalidatesTags: ['Notifications']
    }),
    markAllNotificationsRead: builder.mutation<void, { profileId: string }>({
      query: ({ profileId }) => ({
        url: `profiles/${profileId}/relationships/notifications/read-all`,
        method: 'POST'
      }),
      invalidatesTags: ['Notifications']
    })
  })
});

export const { useGetNotificationsQuery, useMarkNotificationReadMutation, useMarkAllNotificationsReadMutation } =
  notificationsApi;

export { PAGE_SIZE as NOTIFICATIONS_PAGE_SIZE };
